const initialState = {
  gettingPassengers: false,
  passengers: []
}

export const ADD_PASSENGER = 'ADD_PASSENGER'
export const SET_PASSENGERS = 'SET_PASSENGERS'
export const SET_GETTING_PASSENGERS = 'SET_GETTING_PASSENGERS'

export default function passengers(state = initialState, action) {
  switch (action.type) {
    case SET_GETTING_PASSENGERS: {
      const { gettingPassengers } = action
      return Object.assign({}, state, { gettingPassengers })
    }
    case SET_PASSENGERS: {
      const { passengers } = action
      return Object.assign({}, state, { passengers })
    }
    default: {
      return state
    }
  }
}